import React from "react";
import { NavLink } from "react-router-dom";

/**
 * BottomNavBar
 * Fixed bottom navigation with Material Symbols icons + labels.
 */
export default function BottomNavBar({ className = "" }) {
  const items = [
    { to: "/home", icon: "home", label: "Home" },
    { to: "/recording", icon: "radio_button_checked", label: "Record" },
    { to: "/settings", icon: "settings", label: "Settings" },
  ];

  const base = "flex flex-col items-center justify-center gap-1 py-2 min-w-0";
  const textBase = "text-[11px] leading-none";

  return (
    <nav
      className={`md:hidden h-fit z-50 bg-container `}
      aria-label="Bottom navigation"
    >
      <ul className="grid grid-cols-3  h-fit">
        {items.map(({ to, icon, label }) => (
          <li key={to} className="contents">
            <NavLink
              to={to}
              className={({ isActive }) =>
                [base, isActive ? "text-primary" : "text-greyscale-1"].join(" ")
              }
              aria-label={label}
            >
              <span
                className="material-symbols-outlined text-[24px]"
                aria-hidden="true"
              >
                {icon}
              </span>
              <span className={textBase}>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
